const defaults = {
  inputData: '',
  delimiter: ',',
  hasHeaders: true,
  trimValues: true,
  skipEmptyLines: true,
};

export default defaults;
